<template>
    <div>
        <div v-if="inTable">
            <div v-if="fileList.length" :class="{ 'file-preview-container': limit > 1 }">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImage(file.name)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else-if="isVideo(file.name)" class="file-preview-content">
                        <video controls :src="file.url" class="file-preview-video"></video>
                    </div>
                    <div v-else class="file-preview-file">
                        <i class="el-icon-document file-icon"></i>
                        <span class="file-name">{{ file.name }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImage(file.name)" @click="downloadImage(file)" class="el-icon-download" style="color: aliceblue;">下载</i>
                        <i v-else-if="isVideo(file.name)" @click="downloadImage(file)"
                            class="el-icon-video-camera">下载</i>
                        <i v-else @click.stop="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click.stop="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
            <el-upload ref="upload" :action="action" :multiple="multiple" :limit="limit" :on-exceed="handleExceed"
                :before-upload="beforeUpload" :on-preview="downloadFile" :file-list="fileList" :list-type="listTypeMode"
                :http-request="fnUploadRequest" :accept="accept" :show-file-list="false" :on-remove="handleRemove"
                class="custom-upload">
                <i class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件,每个且不超过20M</div>
                </i>
            </el-upload>
        </div>
        <!-- 非表格模式 -->
        <div v-else>
            <el-upload v-if="fileList.length < limit" ref="upload" :action="action" :multiple="multiple" :limit="limit"
                :before-upload="beforeUpload" :on-exceed="handleExceed" :on-preview="downloadFile" :file-list="fileList"
                :http-request="fnUploadRequest" :list-type="listTypeMode" :accept="accept"
                :show-file-list="showFileList" :on-remove="handleRemove">
                <i class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件,且不超过20M</div>
                </i>
            </el-upload>
            <div v-else class="file-preview-container" style="display: block;unicode-bidi: isolate;">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImage(file.name)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else-if="isVideo(file.name)" class="file-preview-content">
                        <video controls :src="file.url" class="file-preview-video"></video>
                    </div>
                    <div v-else class="file-preview-content">
                        <i class="el-icon-document file-icon"></i>
                        <span class="file-name">{{ file.name }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImage(file.name)" @click.stop="downloadImage(file)" class="el-icon-view">下载</i>
                        <i v-else-if="isVideo(file.name)" @click.stop="downloadImage(file)"
                            class="el-icon-video-camera">下载</i>
                        <i v-else @click.stop="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click.stop="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
        </div>
        <!-- 图片和视频下载对话框 -->
        <el-dialog width="60%" append-to-body :visible.sync="dialogVisible">
            <template v-if="isImage(dialogFileUrl)">
                <img width="100%" :src="dialogFileUrl" alt="" />
            </template>
            <template v-else-if="isVideo(dialogFileUrl)">
                <video controls width="100%" :src="dialogFileUrl"></video>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";

export default {
    name: "ImageUpload",
    props: {
        inTable: {
            type: Boolean,
            default: false,
        },
        showPlusAndDel: {
            type: Boolean,
            default: true,
        },
        action: {
            type: String,
            default: '#',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        limit: {
            type: Number,
            default: 1,
        },
        showFileList: {
            type: Boolean,
            default: true,
        },
        uploadedImages: {
            type: [Array, String],
            default: () => [],
        },
        listTypeMode: {
            type: String,
            default: 'picture',
        },
        accept: {
            type: String,
            default: '*/*',  // 任意文件类型
        },
    },
    data() {
        return {
            fileList: [],
            dialogFileUrl: "",
            dialogVisible: false,
            localUploadedImages: [] // 本地上传的图片列表
        };
    },
    watch: {
        uploadedImages: {
            immediate: true,
            handler() {
                this.initializeFileList();
            }
        }
    },
    mounted() {
        this.initializeFileList();
    },
    created() {
        this.initializeFileList();
    },
    methods: {
        beforeUpload(file) {
            const isLt20M = file.size / 1024 / 1024 < 20;
            if (!isLt20M) {
                this.$message.error('文件大小不能超过 20MB');
            }
            return isLt20M; // 返回 false 将阻止文件上传
        },
        isImage(url) {
            return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
        },
        isVideo(url) {
            return /\.(mp4|avi|mov|wmv|flv|mkv|webm)$/i.test(url);
        },
        downloadFile(fileUrl) {
            if (!fileUrl) return;
            // 去掉 query 参数后再提取文件后缀
            const cleanUrl = fileUrl.split('?')[0];
            const fileExtension = (cleanUrl.split('.').pop() || '').toLowerCase();

            // 判断文件类型
            if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(fileExtension)) {
                // 图片文件，通过 <a> 标签下载
                this.downloadUsingAnchor(fileUrl);
            } else if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'txt', 'csv', 'zip', 'rar', 'wps', 'et'].includes(fileExtension)) {
                // 文档和其他文件，通过 fetch + Blob 下载
                this.downloadUsingFetch(fileUrl);
            } else {
                // 其他文件，默认通过 iframe 下载
                this.downloadUsingIframe(fileUrl);
            }
        },

        // 使用 <a> 标签方式下载文件
        downloadUsingAnchor(fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = this.getDownloadFileName(fileUrl); // 设置下载文件名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        // 使用 fetch + Blob 下载文件
        // 使用普通 fetch（不设 no-cors），避免拿到不可读的 opaque body 导致下载空文件
        downloadUsingFetch(fileUrl) {
            fetch(fileUrl)
                .then(response => {
                    if (!response.ok) throw new Error('download failed');
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob); // 创建 Blob URL
                    link.href = url;
                    link.download = this.getDownloadFileName(fileUrl); // 设置下载文件名
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url); // 释放 URL
                })
                .catch(() => {
                    // fetch 失败（如 OSS 未开启 CORS）：
                    // 对 OSS 链接追加 response-content-disposition=attachment 强制下载
                    const isSignedUrl = /([?&])(OSSAccessKeyId|Signature|X-OSS-Process)=/.test(fileUrl);
                    if (!isSignedUrl) {
                        const separator = fileUrl.includes('?') ? '&' : '?';
                        window.open(fileUrl + separator + 'response-content-disposition=attachment', '_blank');
                    } else {
                        // 签名 URL 无法追加参数（会破坏签名），退化为 iframe 下载
                        this.downloadUsingIframe(fileUrl);
                    }
                });
        },

        // 从 URL 中解析下载文件名（去掉 query 参数，并解码中文）
        getDownloadFileName(url) {
            if (!url) return '附件';
            const name = url.split('?')[0].split('/').pop();
            try {
                return decodeURIComponent(name || '附件');
            } catch (e) {
                return name || '附件';
            }
        },

        // 使用 iframe 下载文件（适用于大部分文件，浏览器直接处理）
        downloadUsingIframe(fileUrl) {
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = fileUrl;
            document.body.appendChild(iframe);
            iframe.onload = () => {
                document.body.removeChild(iframe);
            };
        },
        downloadImage(file) {
            const targetUrl = file.url;
            fetch(targetUrl, { mode: 'no-cors' })
                .then(response => response.blob())  // 获取图片的 Blob 数据
                .then(blob => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = file.name;
                    a.click();
                    URL.revokeObjectURL(url);
                })
                .catch(error => {
                    console.error('下载图片失败:', error);
                });
        },
        initializeFileList() {
            let images = [];
            if (typeof this.uploadedImages === 'string' && this.uploadedImages.length > 0) {
                images = this.uploadedImages.split(',').map(url => url.trim()).filter(url => url);
            } else if (Array.isArray(this.uploadedImages)) {
                images = this.uploadedImages.map(image => typeof image === 'object' ? image.url : image);
            }

            this.fileList = images.map(url => ({
                name: url.split('/').pop(),
                url: url,
            }));

            this.localUploadedImages = [...this.fileList];
        },
        handleRemove(file) {
            this.fileList = this.fileList.filter(item => item.url !== file.url);
            this.localUploadedImages = this.fileList; // 删除后更新本地上传图片列表
            this.$emit('uploaded', this.fileList);
        },
        handleExceed() {
            this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
        },
        handlePreview(file) {
            this.dialogFileUrl = file.url;
            this.dialogVisible = true;
        },
        async fnUploadRequest(option) {
            try {
                const res = await getAliyunPublicToken();
                const data = JSON.parse(res.data);
                console.log('data::: ', data);
                const client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });
                // OSS ObjectKey 只允许字母、数字、_、-、.，用「时间戳 + 随机串 + 扩展名」命名，杜绝空格/+/() 等编码问题
                const randomStr = Math.random().toString(36).slice(2, 10);
                const ext = (option.file.name.split('.').pop() || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                const storeAs = Date.now() + '_' + randomStr + (ext ? '.' + ext : '');
                const results = await client.multipartUpload(storeAs, option.file, {
                    headers: {
                        'Content-Type': option.file.type,
                    }
                });
                const url = decodeURIComponent(results.res.requestUrls[0].split("?")[0]);
                // 使用onSuccess返回的数据
                option.onSuccess({ url }, option.file);
                // 直接更新fileList
                this.fileList.push({ name: option.file.name, url });
                this.$emit('uploaded', this.fileList);

                // 由于已经更新了fileList，所以这里不需要调用initializeFileList
            } catch (err) {
                this.$message.error('文件上传失败');
            }
        },
    },
};
</script>

<style scoped>
.custom-upload .el-upload__input {
    display: none;
}

.file-preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.file-preview-item {
    position: relative;
    display: inline-block;
    margin: 10px;
    height: 100px;
}

.file-preview-content {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 100%;
    background: #f5f7fa;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
}

.file-preview-file {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: max-content;
    height: 100%;
    background: #fff;
    border-radius: 4px;
    color: #909399;
    font-size: 16px;
    text-align: center;
}

.file-preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-image {
    opacity: 0.3;
}

.file-preview-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    gap: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-actions {
    opacity: 1;
}

.file-preview-actions .el-icon-view,
.file-preview-actions .el-icon-delete {
    cursor: pointer;
    font-size: 14px;
    color: #e6a23c;
}

.file-icon {
    font-size: 40px;
    color: #909399;
}

.file-name {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-preview-video {
    width: 200px;
    height: 100px; object-fit: cover;
}
</style>
